<div class="w-full">
  @if (!isEditing()) {
    <!-- View mode -->
    <div
      (click)="startEdit()"
      class="group relative cursor-pointer p-1 border-2 rounded-md border-proffeo-border sm:border-transparent hover:bg-proffeo-surface-muted transition-colors"
    >
      @if (description()) {
        <p class="text-sm text-proffeo-text break-words">{{ description() }}</p>
      } @else {
        <p class="text-sm opacity-80 line-clamp-2">
          {{ 'file-upload-add-description' | translate }}
        </p>
      }
    </div>
  } @else {
    <!-- Edit mode -->
    <div class="p-1">
      <proffeo-ui-textarea-editor
        (saved)="onSaved($event)"
        (cancelled)="isEditing.set(false)"
        [value]="description() ?? ''"
        [maxLength]="MAX_DESCRIPTION_LENGTH"
      />
    </div>
  }
</div>
